// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 962 ? "QQShare" : chunkId) + "." + {"388":"a74348afd0","962":"d9628ff9f7"}[chunkId] + ".js";
};